import { Box } from '@rsos/base-components';
import styled from '@rsos/theme/styled';

export const Wrapper = styled(Box)`
  background-color: ${props => props.theme.colors.background};
  border: 1px solid ${props => props.theme.colors.heavyLineOutline};
  border-radius: 5px;
  padding: 16px;
  color: ${props => props.theme.colors.primaryText};
`;
